import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-suspension-report',
    templateUrl: './suspension-report.component.html',
    styleUrls: ['./suspension-report.component.scss']
})
export class SuspensionReportComponent implements OnInit {
    suspensionReportForm: FormGroup
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    toMinDate: Date;
    toMaxDate = new Date()
    constructor(private fb: FormBuilder, private reportService: ReportService) { }

    ngOnInit(): void {
        this.init()
    }
    init() {
        this.suspensionReportForm = this.fb.group({
            startDate: [null],
            endDate: [null],
        });
    }
    Reset() {
        this.suspensionReportForm.reset()
    }

    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.suspensionReportForm.controls["startDate"].value;
        // this.toMaxDate = this.addMonths(this.toMinDate, 3);
    }
    generateExcel() {
        debugger
        if (this.suspensionReportForm.value.startDate || this.suspensionReportForm.value.endDate) {
            if (!this.suspensionReportForm.value.startDate && !this.suspensionReportForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'From date and To date should not be empty',
                    position: 'center',

                })
                return
            }
            else if (!this.suspensionReportForm.value.startDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'From date should not be empty',
                    position: 'center',

                })
                return

            }
            else if (!this.suspensionReportForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'End date should not be empty',
                    position: 'center',

                })
                return

            }
            else if (this.suspensionReportForm.value.startDate > this.suspensionReportForm.value.endDate) {
                if (this.suspensionReportForm.value.endDate) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'End Date should be greater than Start Date',
                        position: 'center',
                    })
                    return
                }

            }
        }
        this.reportService.getSuspensionReport(this.suspensionReportForm.value).subscribe((data) => {
            if (data) {
                const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                const downloadLink = document.createElement('a');
                const fileName = 'SuspendedCustomerDetails.xlsx';
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }
        });
    }
}
